var $f001bdeca5044d08$exports = {};
// Animazioni della landing del check-up: reveal allo scroll, scene animate
// (gauge, barre, gradini, piano) e contatori. Le scene nell'HTML partono già
// nello stato finale: qui le "armiamo" (stato iniziale) solo se il JS gira e
// l'utente non preferisce il movimento ridotto, poi le accendiamo al viewport.
const $f001bdeca5044d08$var$reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function $f001bdeca5044d08$var$animateCount(el) {
    const target = Number(el.dataset.countup);
    if (!Number.isFinite(target) || target <= 0) return;
    const suffix = el.dataset.countupSuffix || '';
    const started = performance.now();
    const duration = 1100;
    const tick = (now)=>{
        const progress = Math.min((now - started) / duration, 1);
        // Ease-out: parte veloce e rallenta sul valore finale
        const eased = 1 - Math.pow(1 - progress, 3);
        el.innerHTML = Math.round(target * eased) + suffix;
        if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
}
function $f001bdeca5044d08$var$init() {
    const targets = document.querySelectorAll('[data-scene], .reveal');
    if (!targets.length) return;
    if ($f001bdeca5044d08$var$reduced || !('IntersectionObserver' in window)) return;
    targets.forEach((el)=>el.classList.add('is-armed'));
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-on');
            entry.target.querySelectorAll('[data-countup]').forEach($f001bdeca5044d08$var$animateCount);
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.35,
        rootMargin: '0px 0px -40px 0px'
    });
    targets.forEach((el)=>observer.observe(el));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $f001bdeca5044d08$var$init);
else $f001bdeca5044d08$var$init();


//# sourceMappingURL=check-up-finanziario.666e9f72.js.map
